module.exports = __webpack_public_path__ + "static/media/divansoffa.37ae52d1.jpg";